import { createClient } from '@supabase/supabase-js';

const SUPA_URL = import.meta.env.VITE_SUPA_URL;
const SUPA_KEY = import.meta.env.VITE_SUPA_ANON_KEY;

if (!SUPA_URL || !SUPA_KEY) {
  throw new Error('Missing VITE_SUPA_URL or VITE_SUPA_ANON_KEY in .env');
}

export const supabase = createClient(SUPA_URL, SUPA_KEY);
